var _mask, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralActionRadioOn = function SvgGeneralActionRadioOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "general-action-radio-on_svg__a",
    width: 22,
    height: 22,
    x: 1,
    y: 1,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1.5 1.5h21v21h-21z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#general-action-radio-on_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    fillRule: "evenodd",
    d: "M12 2.605C6.82 2.605 2.606 6.82 2.606 12S6.819 21.395 12 21.395c5.18 0 9.394-4.215 9.394-9.395S17.181 2.605 12 2.605M12 22.5C6.21 22.5 1.5 17.79 1.5 12S6.21 1.5 12 1.5 22.5 6.21 22.5 12 17.79 22.5 12 22.5",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    fillRule: "evenodd",
    d: "M17.775 12A5.774 5.774 0 0 1 12 17.775 5.774 5.774 0 0 1 6.225 12 5.774 5.774 0 0 1 12 6.225 5.774 5.774 0 0 1 17.775 12",
    clipRule: "evenodd"
  })));
};
export default SvgGeneralActionRadioOn;